import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useState, type ReactNode } from 'react';
import { useSession } from '../session.js';
import { createDashboardQueryClient } from './query-client.js';

export function DashboardQueryProvider({ children }: { children: ReactNode }): ReactNode {
  const { handleUnauthorized, status } = useSession();
  const [client] = useState(() => createDashboardQueryClient(handleUnauthorized));

  useEffect(() => {
    if (status === 'signed-out') client.clear();
  }, [client, status]);

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
